import React, { useState } from "react";
import {
  Form,
  Label,
  Input,
  FormGroup,
  Button
} from "reactstrap";
import "../form.css";
import "bootstrap/dist/css/bootstrap.css";
import { useNavigate } from "react-router-dom";


const LoginForm = ({ login }) => {
  const INITIAL_STATE = {
    username: "",
    password: "",
  };

  const [fData, setFormData] = useState(INITIAL_STATE);
  const [formErrors, setFormErrors] = useState([]);
  const navigate = useNavigate();

  const handleChange = (evt) => {
    const { name, value } = evt.target;
    setFormData((fData) => ({
      ...fData,
      [name]: value,
    }));
  };

  console.debug(
    "LoginForm",
    "login=",
    typeof login,
    "formData=",
    fData,
    "formErrors",
    formErrors,
  );
  async function handleSubmit(evt) {
    evt.preventDefault();
    console.log(fData);
    let result = await login(fData);
    //  setToken(window.localStorage.getItem("token"))
    //  console.log(token);
    // alert(` user ${fData.username}, password ${fData.password}`)
    if (result.success) {
      console.log(result);
      navigate("/");
    } else {
      console.log(result.errors);
      setFormErrors([result.errors.message]);
    }
  }

  return (
    <>
      {/* {formErrors.length ? (
        <AlertMade type="danger" messages={formErrors} />
      ) : null} */}
      <h2> Login</h2>
      <h1 className="formHeader">Get back to working hard</h1>
      <Form className="formBody" onSubmit={handleSubmit}>
        <FormGroup>
          <Label className="labelTitle" htmlFor="username">
            Username
          </Label>
          <Input
            id="username"
            name="username"
            placeholder="Place Your Username Here"
            type="text"
            value={fData.username}
            onChange={handleChange}
            required
          />
        </FormGroup>
        <FormGroup>
          <Label className="labelTitle" htmlFor="password">
            Password
          </Label>
          <Input
            id="password"
            name="password"
            placeholder="Place Your Passwords Here"
            type="password"
            value={fData.password}
            onChange={handleChange}
            required
          />
        </FormGroup>
        <Button color="primary">Submit</Button>
      </Form>
    </>
  );
};

export default LoginForm;
